export default __webpack_public_path__ + "static/media/b5.5576f08f.png";